var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"related-products-placeholder"},[_c('div',{staticClass:"related-products-placeholder__heading"}),_vm._l((3),function(index){return _c('RelatedProductPlaceholder',{key:index})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }